import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useStyles from '../makeStyles';

const FieldLabel = ({ labelKey, required }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  if (labelKey && required) {
    return (
      <span className={classes.requiredLabel}>
        {t(labelKey)}
        <p className={classes.star}>*</p>
      </span>
    );
  }
  return labelKey.length ? t(labelKey) : labelKey;
};

FieldLabel.propTypes = {
  labelKey: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

FieldLabel.defaultProps = {
  required: false,
};

export default FieldLabel;
